import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

import _isNil from 'lodash/isNil';

import {
  encodeUri,
  getSchemeFromValue,
  HTTP_URI_SCHEME,
  needEncoding,
  stripScheme,
} from 'libs/urls';

import { getInitialValueState } from './URISchemeField.utils';

const propTypes = {
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  required: PropTypes.bool,
};

const defaultProps = {
  value: null,
  defaultValue: '',
  className: '',
  placeholder: 'example.com',
  disabled: false,
  name: '',
  required: false,
};

function URISchemeField({
  defaultValue,
  value: valueProp,
  className,
  placeholder,
  onChange,
  disabled,
  name,
  required,
}) {
  const isControlled = !_isNil(valueProp);
  const [value, setValue] = useState(getInitialValueState(defaultValue));
  const finalValue = isControlled ? valueProp : value;
  const finalScheme = getSchemeFromValue(finalValue, { defaultScheme: HTTP_URI_SCHEME });

  function handleInputChange(e, target) {
    const { value: newValue } = target;
    const newScheme = getSchemeFromValue(newValue) || finalScheme;

    const currentUri = stripScheme(newValue);
    let finalNewValue = newScheme + currentUri;

    if (!isControlled) {
      setValue(finalNewValue);
    }

    const shouldEncode = needEncoding(newScheme);
    if (shouldEncode) {
      finalNewValue = encodeUri(finalNewValue);
    }
    const newTarget = { ...target, value: finalNewValue };
    onChange({ ...e, target: newTarget }, newTarget);
  }

  return (
    <Input
      label={finalScheme}
      value={stripScheme(finalValue)}
      type="text"
      onChange={handleInputChange}
      placeholder={placeholder}
      disabled={disabled}
      name={name}
      required={required}
      className={className}
    />
  );
}

export default URISchemeField;

URISchemeField.propTypes = propTypes;
URISchemeField.defaultProps = defaultProps;
